import type { FaireProductEntity } from "../../entity_types/product";

export const p_s928nn3vmg: FaireProductEntity = {
  token: "p_s928nn3vmg",
  type: "product",
  name: "Enamel Summer Daisy Charm",
  brandToken: "b_88zusr2wye",
  brandName: "Goldie Charm Bar",
  imageUrl:
    "https://cdn.faire.com/fastly/185df459f2cf982d98dc6000ee5394183e1890ef6d7f990c5417d019c1c872e2.png",
  galleryImageUrls: [],
  priceDollars: 7.58,
  description:
    "Summer Daisy Charm - Enamel Gold Summer Charm for Boutique Charm Bars\n\nDETAILS\nEnamel Daisy\n\nMATERIAL\n14k Gold Filled\n\nAll Goldie Jewelry Studio charms are 100% lead + nickel free: hypoallergenic, anti-tarnish, waterproof.\n",
  tags: [],
  msrpDollars: 22.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:27.704Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
